import type { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

import { ViewCountersActions } from './view-counters.store';
import { ViewsHttpService } from '../../services/views-http.service';

@Injectable({ providedIn: 'root' })
export class ViewCountersEffects {
  public fetchOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ViewCountersActions.fetchCollection),
      mergeMap(({ payload: { dataSourceId, ids } }) =>
        this.viewsHttpService.fetchViewCounters(dataSourceId, ids).pipe(
          map(data =>
            ViewCountersActions.fetchCollectionSuccess({ payload: { scope: dataSourceId, data } }),
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              ViewCountersActions.fetchCollectionFailed({
                payload: { scope: dataSourceId, error },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private viewsHttpService: ViewsHttpService,
  ) {}
}
